import { Component, computed, ViewChild, ElementRef, Output, EventEmitter, NgZone, effect, Input, signal, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { LookupItem, LookupService } from '@app/common-codes/services/LookupService';
import { PermissionsService } from '@app/common-codes/services/Permissions.service';
import { AccountBase } from '@app/common-codes/models/AccountBase.model';


@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule]
})
export abstract class AccountBaseDetailComponent<T extends AccountBase> extends GenetricDetailComponent<T> {

  // override ComponentEntityClass = Account;
  Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  @Output() itemSaved = new EventEmitter<T>();
  roleLookup = signal<LookupItem[]>([]);
  languageLookup = signal<LookupItem[]>([]);





  constructor(
    route: ActivatedRoute,
    router: Router,
    translationService: TranslationService,
    validationService: GenericValidationService,
    alertModalService: AlertModalService,
    permissionsService: PermissionsService,
    ngZone: NgZone
  ) {
    super(route, router, translationService, validationService, ngZone);
    this.alertModalService = alertModalService;
    // effect(() => {
    //   const entity = this.editingEntity();
    //   if (entity) {
    //     this.roleLookup.set(this.getLookupData('Role'));
    //     this.languageLookup.set(this.getLookupData('i18nLanguage'));

    //   }
    // });
  }



  override parseToEntityInstance(): void {
    if (this.EntityInstance && this.editingEntity()) {
      Object.assign(this.EntityInstance, this.editingEntity());
    }
  }




  onRoleChange(event: Event): void {
    const newValue = +(event.target as HTMLSelectElement).value;
    const currentEntity = this.editingEntity();
    if (currentEntity) {
      // const newEntity = Object.assign(new T(), currentEntity);
      currentEntity.fK_Role = newValue;
      const role = this.roleLookup()?.filter(r => r.key === `${newValue}`);
      if (role && role.length > 0) {
        currentEntity.roleTitle = role[0].value;
        const defaultPermissions = JSON.parse(role[0].additionalData['defaultpermissions']);
        currentEntity.permissions = JSON.stringify(this.permissionsService.InferAccountPermissionsFromDefault(defaultPermissions)); // JSON.stringify(permissionsData);
      }
      this.editingEntity.set(currentEntity);
    }
  }

  async saveItem(): Promise<void> {
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
    }
  }

  async saveAndCloseItem(): Promise<void> {
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
      this.closeModal.emit();
    }
  }

}
